import BasicInformation from "@pages/me/BasicInformation";
import { useEffect, useMemo, useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import Usage from "./Usage";
import { LinkedAccountGuard } from "./LinkedAccount/LinkedAccountGuard";
import { enableTiktokEntry } from "@utils/enableTiktokEntry";
import { SettingHeader } from "./SettingHeader/SettingHeader";
import { twMerge } from "tailwind-merge";
import { ThemeAwareClassName } from "@components/ThemeAwareClassName";
import { useAtomValue } from "jotai";
import { themeAtom } from "@src/jotai/theme";

export const PageMe = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get("tab") || "basic");
  const isDark = useAtomValue(themeAtom) === "dark";
  const tabActiveBgClass = isDark ? "bg-palette-base-white-alpha-3" : "bg-kds-bg-overlay";
  const tabHoverBgClass = isDark ? "hover:bg-palette-base-white-alpha-3" : "hover:bg-kds-bg-overlay";

  const tabOptions = useMemo(
    () => [
      { label: "Profile", value: "basic" },
      { label: "Usage", value: "usage" },
      ...(enableTiktokEntry() ? [{ label: "Linked Accounts", value: "linkedAccounts" }] : []),
    ],
    [],
  );

  useEffect(() => {
    const currentTab = searchParams.get("tab") || "basic";
    setTab(currentTab);
  }, [searchParams]);

  return (
    <div className="h-screen flex flex-col">
      <SettingHeader onClick={() => navigate("/video")} />
      <div className="flex-1 min-h-0 flex flex-row items-start gap-[16px] justify-center py-[16px]">
        <ThemeAwareClassName
          as="div"
          className="flex flex-col gap-px w-[192px] rounded-[12px] p-[8px] bg-kds-bg border"
          lightClassName="border-kds-border-subtle"
          darkClassName="border-kds-border"
        >
          {tabOptions.map((option) => {
            return (
              <div
                key={option.value}
                className={twMerge(
                  "flex flex-row h-[38px] p-[8px] items-center gap-[4px] cursor-pointer rounded-[4px] text-kds-fg",
                  tabHoverBgClass,
                  "text-[14px] leading-[22px] font-normal",
                  option.value === tab ? `${tabActiveBgClass} font-semibold` : "",
                )}
                onClick={() => navigate(`/me?tab=${option.value}`)}
              >
                <Trans>{option.label}</Trans>
              </div>
            );
          })}
        </ThemeAwareClassName>
        <ThemeAwareClassName
          className="w-[982px] p-[24px] rounded-[12px] bg-kds-bg h-full overflow-auto border"
          lightClassName="border-kds-border-subtle"
          darkClassName="border-kds-border"
        >
          {tab === "basic" && <BasicInformation></BasicInformation>}
          {tab === "usage" && <Usage></Usage>}
          {tab === "linkedAccounts" && <LinkedAccountGuard />}
        </ThemeAwareClassName>
      </div>
    </div>
  );
};
